import { BaSeContainer } from '@base/react';
import styled from 'styled-components';

export const Container = styled(BaSeContainer)`
  height: 60vh;
  display: flex;
  align-items: start;
  justify-content: center;
  padding-bottom: 5px;
`;

export const AlignCustomFilter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const AlignButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;
